//here the i18n translation must be applied over the title
export const _init_time_based_conditions = [
	{
		title: 'collapse_title_timer',
		props: {
			_gui_type: 'timer',
			icon: 'fad fa-timer',
		},
	},
	{
		title: 'collapse_title_daily_weekly_schedule',
		props: {
			_gui_type: 'd_cond',
			icon: 'fa-light fa-calendar',
		},
	},
	{
		title: 'collapse_title_one_time',
		props: {
			_gui_type: 'ot_cond',
			icon: 'fa fa-calendar-day',
		},
	},
];
